function isGuestMaintenanceEnabled(settings) {
    const setting = (settings || []).find((item) => item.name === 'guest-maintenance');

    if (!setting) {
        return false;
    }

    return !!Number(setting.value);
}

function shouldShowGuestMaintenance({ settings, isAuthenticated, routeName }) {
    if (routeName === 'login' || isAuthenticated) {
        return false;
    }

    return isGuestMaintenanceEnabled(settings);
}

function translatedName(record, locale) {
    if (!record) {
        return '';
    }

    const translated = record.translatable && record.translatable.name
        ? record.translatable.name[locale]
        : '';

    if (typeof translated === 'string' && translated.trim() !== '') {
        return translated.trim();
    }

    return typeof record.name === 'string' ? record.name.trim() : '';
}

function maintenanceProjectName(projects, locale) {
    return translatedName((projects || [])[0], locale);
}

function maintenanceLogo(settings) {
    const rows = settings || [];
    const dark = rows.find((item) => item.name === 'black-logo');
    const light = rows.find((item) => item.name === 'white-logo');

    return (dark && dark.image && dark.image.url) || (light && light.image && light.image.url) || null;
}

module.exports = {
    isGuestMaintenanceEnabled,
    shouldShowGuestMaintenance,
    maintenanceProjectName,
    maintenanceLogo,
};
